module.exports = __webpack_public_path__ + "static/media/back.3eff3486.svg";